import React from 'react';
import styled from 'astroturf/react';
import _ParentDiv from "CenteredDiv-ParentDiv.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/login_modal/components/CenteredDiv.tsx?styleId=ParentDiv";
import _ChildDiv from "CenteredDiv-ChildDiv.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/login_modal/components/CenteredDiv.tsx?styleId=ChildDiv";


const ParentDiv = /*#__PURE__*/styled("div", null, {
  displayName: "ParentDiv",
  styles: _ParentDiv
});
const ChildDiv = /*#__PURE__*/styled("div", null, {
  displayName: "ChildDiv",
  styles: _ChildDiv
});

export const CenteredDiv: React.FC<React.PropsWithChildren> = (props) => {
  return (
    <ParentDiv>
      <ChildDiv>{props.children}</ChildDiv>
    </ParentDiv>
  );
};
